// extracted by mini-css-extract-plugin
module.exports = {"Layout":"OffsetLinkDetails_Layout__1wpgZ","LayoutContainer":"OffsetLinkDetails_LayoutContainer__qW_41","NoMargin":"OffsetLinkDetails_NoMargin__AfMUl"};